// extracted by mini-css-extract-plugin
module.exports = {"teamPicture":"teampicture-module--teamPicture--395rj"};